import Vue from 'vue';
import moment from 'moment';
import {
  datePickerFormat,
} from '@/constants';

export default Vue.extend({
  methods: {
    allowedDateOfBirthDates(dob): boolean {
      return moment(dob, datePickerFormat).isSameOrBefore(moment(), 'day');
    },
  },
});
